// // import logo from './logo.svg';
// // import './App.css';

// // function App() {
// //   return (
// //     <div className="App">
// //       <header className="App-header">
// //         <img src={logo} className="App-logo" alt="logo" />
// //         <p>
// //           Edit <code>src/App.js</code> and save to reload.
// //         </p>
// //         <a
// //           className="App-link"
// //           href="https://reactjs.org"
// //           target="_blank"
// //           rel="noopener noreferrer"
// //         >
// //           Learn React
// //         </a>
// //       </header>
// //     </div>
// //   );
// // }

// // export default App;



// import React from "react";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   Container,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   IconButton,
//   ThemeProvider,
//   createTheme,
//   CssBaseline,
//   Chip,
//   useScrollTrigger,
//   Fab,
//   Zoom,
// } from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid2";
// import Bg_Image from './assets/Bg_Image/bg_image.jpg';
// import {
//   PlayArrow,
//   Psychology,
//   People,
//   Link as LinkIcon,
//   Security,
//   Insights,
//   ViewModule,
//   TrendingUp,
//   Groups,
//   Description,
//   Task,
//   Receipt,
//   Web,
//   Business,
//   Gavel,
//   Palette,
//   Shield,
//   Code,
//   Lock,
//   CheckCircle,
//   Storage,
//   SupervisedUserCircle,
//   Twitter,
//   LinkedIn,
//   GitHub,
//   KeyboardArrowUp,
// } from "@mui/icons-material";
// import fav from "../src/assets/logo192.png"
// import { Link, useNavigate } from "react-router-dom";



// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#2563eb",
//     },
//     secondary: {
//       main: "#1e293b",
//     },
//   },
//   typography: {
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     h1: {
//       fontWeight: 700,
//       fontSize: "3.5rem",
//     },
//     h2: {
//       fontWeight: 700,
//       fontSize: "2.5rem",
//     },
//     h4: {
//       fontWeight: 600,
//     },
//   },
// });

// // Scroll to Top Button Component
// function ScrollTop(props) {
//   const { children, window } = props;
//   const trigger = useScrollTrigger({
//     target: window ? window() : undefined,
//     disableHysteresis: true,
//     threshold: 100,
//   });

//   const handleClick = (event) => {
//     const anchor = (event.target.ownerDocument || document).querySelector(
//       "#back-to-top-anchor"
//     );
//     if (anchor) {
//       anchor.scrollIntoView({
//         block: "center",
//         behavior: "smooth",
//       });
//     }
//   };

//   return (
//     <Zoom in={trigger}>
//       <Box
//         onClick={handleClick}
//         role="presentation"
//         sx={{ position: "fixed", bottom: 16, right: 16 }}
//       >
//         {children}
//       </Box>
//     </Zoom>
//   );
// }

// export default function SynthiumLanding() {
//   const navigate = useNavigate();

//   const scrollToSection = (sectionId) => {
//     navigate(`#${sectionId}`);
//     setTimeout(() => {
//       const element = document.getElementById(sectionId);
//       if (element) {
//         element.scrollIntoView({ behavior: "smooth", block: "start" });
//       }
//     }, 100);
//   };

//   const securityFeatures = [
//     {
//       icon: Lock,
//       title: "End-to-End Encryption",
//       description:
//         "AES-256 encryption with HSM key rotation ensures your data is always protected.",
//     },
//     {
//       icon: Security,
//       title: "Compliance Ready",
//       description:
//         "GDPR, HIPAA, SOC 2, and CCPA ready with automated compliance reporting.",
//     },
//     {
//       icon: Description,
//       title: "Immutable Audit Logs",
//       description:
//         "Complete audit trails via Synthium Secure's AuditChain for full transparency.",
//     },
//     {
//       icon: SupervisedUserCircle,
//       title: "Granular Access Control",
//       description:
//         "Role-based access control with granular sharing for internal and external collaborators.",
//     },
//   ];

//   const features = [
//     {
//       icon: Psychology,
//       title: "AI-Enhanced Intelligence",
//       description:
//         "AI suggests next steps, analyzes deal health, and provides actionable insights that empower your team without overwhelming them.",
//     },
//     {
//       icon: People,
//       title: "Human-Centered Design",
//       description:
//         "Intuitive interface designed for real people doing real work. Get productive from day one with minimal training required.",
//     },
//     {
//       icon: LinkIcon,
//       title: "Seamless Integration",
//       description:
//         "Connects to all Synthium Suites and external tools like Salesforce, QuickBooks, M365, and more for unified workflows.",
//     },
//     {
//       icon: Security,
//       title: "Enterprise Security",
//       description:
//         "End-to-end AES-256 encryption, GDPR/HIPAA compliance, and immutable audit trails without complexity.",
//     },
//     {
//       icon: Insights,
//       title: "Real-Time Insights",
//       description:
//         "Live key real-time critical information about deal health, workload distribution, and team performance.",
//     },
//     {
//       icon: ViewModule,
//       title: "Fully Modular",
//       description:
//         "Start with Deals, Docs, scale to end-to-end client lifecycle orchestration. Pay only for what you use.",
//     },
//   ];
//   const modules = [
//     {
//       icon: TrendingUp,
//       title: "Deals",
//       description:
//         "AI-guided sales pipeline with risk forecasting, deal scoring, and automated next-step recommendations.",
//       chips: [
//         "Pipeline Management",
//         "Risk Forecasting",
//         "Deal Scoring",
//         "Revenue Predictions",
//       ],
//     },
//     {
//       icon: Groups,
//       title: "Client 360",
//       description:
//         "Unified workspace for contacts, communications, and complete client history with sentiment analysis.",
//       chips: [
//         "Contact Management",
//         "Communication History",
//         "Sentiment Analysis",
//         "Relationship Mapping",
//       ],
//     },
//     {
//       icon: Description,
//       title: "Docs",
//       description:
//         "Real-time collaborative documents with e-signature and Legal Suite compliance checks.",
//       chips: [
//         "Real-time Collaboration",
//         "E-signature Integration",
//         "Compliance Checks",
//         "Version Control",
//       ],
//     },
//     {
//       icon: Task,
//       title: "Tasks",
//       description:
//         "Smart, auto-generated actions linked to contacts, meetings, and client milestones.",
//       chips: [
//         "Auto-generation",
//         "Meeting Integration",
//         "Contract Linking",
//         "Progress Tracking",
//       ],
//     },
//     {
//       icon: Receipt,
//       title: "Invoices",
//       description:
//         "Automated billing synced to contracts and ERP systems with payment tracking.",
//       chips: [
//         "Automated Billing",
//         "ERP Integration",
//         "Payment Tracking",
//         "Revenue Recognition",
//       ],
//     },
//     {
//       icon: Web,
//       title: "Portal",
//       description:
//         "Secure client-facing hub for approvals, payments, feedback, and project collaboration.",
//       chips: [
//         "Client Access",
//         "Approval Workflows",
//         "Payment Processing",
//         "Feedback Collection",
//       ],
//     },
//   ];
//   const Products = [
//     {
//       icon: Business,
//       title: "Enterprise Suite",
//       description:
//         "Shares KPIs, forecasts, and compliance data for strategic decision-making.",
//     },
//     {
//       icon: Gavel,
//       title: "Legal Suite",
//       description:
//         "Validates contracts and flags risks with automated compliance checks.",
//     },
//     {
//       icon: Palette,
//       title: "Creative Suite",
//       description:
//         "Ties campaigns to client ROI and tracks creative project performance.",
//       link: "https://sythiumsuites.com/",
//     },
// {
//       icon: Code,
//       title: "Business Suite",
//       description:
//         "Ties campaigns to Business Professional for contracts and tracks creative RFP's and Proposals.",
//       link: "https://contractpro360.com",
//     },


//     {
//       icon: Shield,
//       title: "Secure Suite",
//       description:
//         "Enforces encryption, RBAC, and maintains immutable audit trails.",
//     },
//     {
//       icon: Code,
//       title: "Developer Suite",
//       description:
//         "Tracks API usage and manages client Products seamlessly.",
//     },
//   ];

//   return (
//     <>
//       <ThemeProvider theme={theme}>
//         <CssBaseline />
//         <Box sx={{ flexGrow: 1 }}>
//           {/* Navigation */}
//           <AppBar
//             position="static"
//             color="transparent"
//             elevation={0}
//             sx={{ borderBottom: "1px solid #e5e7eb" }}
//           >
//             <Toolbar>
//              <Typography
//   variant="h5"
//   sx={{
//     flexGrow: 1,
//     fontWeight: 700,
//     color: "#000",
//     display: "flex",
//     alignItems: "center",   // vertically center logo + text
//     gap: "10px",            // spacing between logo and name
//     fontSize: "34px",  
//   }}
// >
//   <img src={fav} style={{ width:"10%"}} />
//   <span>Synthium Suite</span>
// </Typography>

//               <Button
//                 color="inherit"
//                 sx={{ mx: 1 , fontWeight:600, fontSize: "20px",  }}

//                 onClick={() => scrollToSection("features")}
//               >
//               <bold>FEATURES</bold>  
//               </Button>
//               <Button
//                 color="inherit"
//                   sx={{ mx: 1 , fontWeight:600, fontSize: "20px",  }}
//                 onClick={() => scrollToSection("modules")}
//               >
//                  <bold>MODULES</bold>  
//               </Button>
//               <Button
//                 color="inherit"
//                   sx={{ mx: 1 , fontWeight:600, fontSize: "20px",  }}
//                 onClick={() => scrollToSection("Products")}
//               >
//                 <bold>Products</bold>  
//               </Button>
//               <Button
//                 color="inherit"
//                   sx={{ mx: 1 , fontWeight:600, fontSize: "20px",  }}
//                 onClick={() => scrollToSection("security")}
//               >
//                <bold>SECURITY</bold>  
//               </Button>
//               <Button
//                 variant="contained"
//                 sx={{ ml: 2 }}
//                 onClick={() => window.open("https://sythiumsuites.com", "_blank")}
//               >
//                 Get Started
//               </Button>
//             </Toolbar>
//           </AppBar>

//           {/* Hero Section */}
//           <Box
//             sx={{
//              backgroundImage: `url(${Bg_Image})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               backgroundRepeat: "no-repeat",
//               color: "white",
//               py: 7,
//               position: "relative",
//               overflow: "hidden",
//               minHeight: "700px",
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             <Container maxWidth="lg">
//               <Box
//                 sx={{ textAlign: "center", position: "relative", zIndex: 1 }}
//               >
//                 <Typography variant="h2" gutterBottom sx={{ color: "#ffffffff" }}>
//                 <h2> Where Work Gets Done —</h2>  
//                 </Typography>
//                 <Typography variant="h2" gutterBottom sx={{ color: "#ffffffff" }}>
//                  <h2>Together</h2> 
//                 </Typography>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     mt: 3,
//                     mb: 3,
//                     maxWidth: "800px",
//                     mx: "auto",
//                     opacity: 0.95,
//                   }}
//                 >
//                  <h4>The operational engine of the Synthium ecosystem—designed for
//                   sales, client services, finance, and operations teams to
//                   execute strategy with speed, clarity, and intelligence.</h4> 
//                 </Typography>
//                 <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
//                   <Button
//                     variant="contained"
//                     size="large"
//                     sx={{ px: 1, py: 1, fontSize: "1rem" }}
//                   >
//                     Start Free Trial
//                   </Button>
//                   <Button
//                     variant="outlined"
//                     size="large"
//                     startIcon={<PlayArrow />}
//                     sx={{
//                       px: 2,
//                       py: 1,
//                       fontSize: "1rem",
//                       color: "white",
//                       borderColor: "white",
//                       "&:hover": {
//                         borderColor: "white",
//                         bgcolor: "rgba(255,255,255,0.1)",
//                       },
//                     }}
//                   >
//                     Watch Demo
//                   </Button>
//                 </Box>
//               </Box>
//             </Container>
//           </Box>

//           {/* Features Section */}
//           <Container maxWidth="lg" sx={{ py: 2 }} id="features">
//             <Box sx={{ textAlign: "center", mb: 8 }}>
//               <Typography
//                 variant="h4"
//                 gutterBottom
//                 sx={{
//                   fontWeight: 700,
//                   fontSize: { xs: "2rem", md: "2.5rem" },
//                   mb: 1,
//                 }}
//               >
//                 Built for How You Actually Work
//               </Typography>
//               <Typography
//                 variant="body1"
//                 color="text.secondary"
//                 sx={{
//                   maxWidth: "700px",
//                   mx: "auto",
//                   fontSize: "1rem",
//                   lineHeight: 1.3,
//                 }}
//               >
//                 Every feature designed to turn everyday tasks into structured,
//                 secure, and AI-enhanced workflows that feed real-time insight
//                 back into your enterprise strategy.
//               </Typography>
//             </Box>

//             <Grid container spacing={2}>
//               {features.map((feature, index) => (
//                 <Grid key={index} xs={12} sm={6} md={4}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       boxShadow:
//                         "0 2px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
//                       borderRadius: 2,
//                       border: "1px solid #f1f5f9",
//                       transition: "box-shadow 0.3s ease",
//                       "&:hover": {
//                         boxShadow:
//                           "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
//                       },
//                     }}
//                   >
//                     <CardContent sx={{ p: 2 }}>
//                       <Box
//                         sx={{
//                           bgcolor: "#eff6ff",
//                           borderRadius: 2,
//                           p: 1,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           mb: 1,
//                         }}
//                       >
//                         <feature.icon sx={{ color: "#2563eb", fontSize: 32 }} />
//                       </Box>

//                       <Typography
//                         variant="h6"
//                         gutterBottom
//                         fontWeight={600}
//                         sx={{
//                           mb: 1,
//                           fontSize: "1.125rem",
//                         }}
//                       >
//                         {feature.title}
//                       </Typography>

//                       <Typography
//                         variant="body2"
//                         color="text.secondary"
//                         sx={{
//                           lineHeight: 1.4,
//                           fontSize: "0.875rem",
//                         }}
//                       >
//                         {feature.description}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           </Container>

//           {/* Modules Section */}
//           <Box sx={{ bgcolor: "#f9fafb", py: 2 }} id="modules">
//             <Container maxWidth="lg">

//               <Box sx={{ textAlign: "center", mb: 2 }}>
//                 <Typography
//                   variant="h4"
//                   gutterBottom
//                   sx={{
//                     fontWeight: 700,
//                     fontSize: { xs: "2rem", md: "2.5rem" },
//                     mb: 1,
//                   }}
//                 >
//                   Six Powerful Modules, One Unified Experience
//                 </Typography>
//                 <Typography
//                   variant="body1"
//                   color="text.secondary"
//                   sx={{
//                     fontSize: "1rem",
//                     lineHeight: 1,
//                   }}
//                 >
//                   Each module is designed to work independently or together,
//                   creating a seamless workflow from first contact to final
//                   invoice.
//                 </Typography>
//               </Box>
//               <Grid container spacing={2}>
//                 {modules.map((module, index) => (
//                   <Grid key={index} xs={12} sm={12} md={6}>
//                     <Card
//                       sx={{
//                         boxShadow:
//                           "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
//                         height: "100%",
//                         borderRadius: 2,
//                         transition: "box-shadow 0.3s ease",
//                         "&:hover": {
//                           boxShadow:
//                             "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
//                         },
//                       }}
//                     >
//                       <CardContent sx={{ p: 3 }}>

//                         <Box
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             mb: 2,
//                           }}
//                         >
//                           <Box
//                             sx={{
//                               bgcolor: "#2563eb",
//                               borderRadius: 2,
//                               p: 1.5,
//                               mr: 2,
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                             }}
//                           >
//                             <module.icon
//                               sx={{ color: "white", fontSize: 28 }}
//                             />
//                           </Box>
//                           <Typography
//                             variant="h5"
//                             fontWeight={600}
//                             sx={{ fontSize: "1.5rem" }}
//                           >
//                             {module.title}
//                           </Typography>
//                         </Box>

//                         <Typography
//                           variant="body2"
//                           color="text.secondary"
//                           paragraph
//                           sx={{
//                             lineHeight: 1.4,
//                             mb: 2,
//                             fontSize: "0.875rem",
//                           }}
//                         >
//                           {module.description}
//                         </Typography>

//                         <Box
//                           sx={{
//                             display: "flex",
//                             flexWrap: "wrap",
//                             gap: 1,
//                           }}
//                         >
//                           {module.chips.map((chip, chipIndex) => (
//                             <Chip
//                               key={chipIndex}
//                               label={chip}
//                               size="small"
//                               sx={{
//                                 bgcolor: "#eff6ff",
//                                 color: "#2563eb",
//                                 fontWeight: 500,
//                                 fontSize: "0.75rem",
//                                 "&:hover": {
//                                   bgcolor: "#dbeafe",
//                                 },
//                               }}
//                             />
//                           ))}
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Container>
//           </Box>


//           <Container maxWidth="lg" sx={{ py: 2 }} id="Products">
//             <Box sx={{ textAlign: "center", mb: 2 }}>
//               <Typography
//                 variant="h4"
//                 gutterBottom
//                 sx={{
//                   fontWeight: 700,
//                   fontSize: { xs: "2rem", md: "2.5rem" },
//                   mb: 2,
//                 }}
//               >
//                 Seamlessly Connected Ecosystem
//               </Typography>
//               <Typography
//                 variant="body1"
//                 color="text.secondary"
//                 sx={{
//                   fontSize: "1rem",
//                   lineHeight: 1,
//                 }}
//               >
//                 Built on Synthium Core with real-time bi-directional integration
//                 across all Synthium Suites and your favorite external tools.
//               </Typography>
//             </Box>
//             <Typography
//               variant="h5"
//               fontWeight={600}
//               sx={{
//                 mb: 3,
//                 textAlign: "center",
//                 fontSize: "1.2rem",
//               }}
//             >
//               Synthium Suite Products
//             </Typography>
//             <Grid container spacing={2}>
//               {Products.map((integration, index) => (
//                 <Grid key={index} xs={12} sm={6} md={4}>
//                   <Card
//                     sx={{
//                       textAlign: "center",
//                       p: 3,
//                       boxShadow:
//                         "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
//                       height: "100%",
//                       borderRadius: 2,
//                       border: "1px solid #f1f5f9",
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         boxShadow:
//                           "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
//                         transform: "translateY(-4px)",
//                       },
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         bgcolor: "#eff6ff",
//                         borderRadius: 2,
//                         p: 2,
//                         display: "inline-flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         mb: 2,
//                       }}
//                     >
//                       <integration.icon
//                         sx={{ color: "#2563eb", fontSize: 40 }}
//                       />
//                     </Box>
//                     <Typography
//                       variant="h6"
//                       fontWeight={600}
//                       gutterBottom
//                       sx={{
//                         fontSize: "1.125rem",
//                         mb: 1.5,
//                       }}
//                     >
//                       {integration.link ? (
//                         <a
//                           href={integration.link}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           style={{
//                             color: "inherit",
//                             textDecoration: "none",
//                           }}
//                         >
//                           {integration.title}
//                         </a>
//                       ) : (
//                         integration.title
//                       )}
//                     </Typography>

//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{
//                         lineHeight: 1.7,
//                         fontSize: "0.875rem",
//                       }}
//                     >
//                       {integration.description}
//                     </Typography>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           </Container>

//           <Box sx={{ bgcolor: "#ffffff", py: 2 }} id="security">
//             <Container maxWidth="lg">
//               <Box sx={{ textAlign: "center", mb: 2 }}>
//                 <Typography
//                   variant="h4"
//                   gutterBottom
//                   sx={{
//                     fontWeight: 700,
//                     fontSize: { xs: "2rem", md: "2.5rem" },
//                     mb: 2,
//                   }}
//                 >
//                   Enterprise-Grade Security Without Complexity
//                 </Typography>
//                 <Typography
//                   variant="body1"
//                   color="text.secondary"
//                   sx={{
//                     maxWidth: "800px",
//                     mx: "auto",
//                     fontSize: "1rem",
//                     lineHeight: 1,
//                   }}
//                 >
//                   Built with security at its core, Synthium Business Suite
//                   provides enterprise-level protection that's simple to manage
//                   and transparent to use.
//                 </Typography>
//               </Box>

//               <Grid container spacing={2}>
//                 {securityFeatures.map((feature, index) => (
//                   <Grid key={index} xs={12} sm={6} md={6}>
//                     <Box sx={{ height: "100%" }}>
//                                            <Box
//                         sx={{
//                           bgcolor: "#2563eb",
//                           borderRadius: 3,
//                           p: 1.5,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           mb: 2,
//                         }}
//                       >
//                         <feature.icon sx={{ color: "#ffffff", fontSize: 20 }} />
//                       </Box>

//                       <Typography
//                         variant="h6"
//                         gutterBottom
//                         fontWeight={600}
//                         sx={{
//                           mb: 1,
//                           fontSize: "1rem",
//                         }}
//                       >
//                         {feature.title}
//                       </Typography>

//                       <Typography
//                         variant="body1"
//                         color="text.secondary"
//                         sx={{
//                           lineHeight: 1.7,
//                           fontSize: "1rem",
//                         }}
//                       >
//                         {feature.description}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Container>
//           </Box>

//           <Box sx={{ bgcolor: "#588cfdff", color: "white", py: 2 }}>
//             <Container maxWidth="md">
//               <Box sx={{ textAlign: "center" }}>
//                 <Typography variant="h4" gutterBottom>
//                   Ready to Transform Your Business Operations?
//                 </Typography>
//                 <Typography variant="h6" sx={{ mb: 2, opacity: 0.95 }}>
//                   Join thousands of teams who have streamlined their workflows
//                   with Synthium Business Suite. Start with a free trial and see
//                   the difference AI-enhanced operations can make.
//                 </Typography>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     gap: 2,
//                     justifyContent: "center",
//                     mb: 2,
//                   }}
//                 >
//                   <Button
//                     variant="contained"
//                     size="large"
//                     sx={{
//                       px: 4,
//                       py: 1,
//                       bgcolor: "white",
//                       color: "#2563eb",
//                       "&:hover": { bgcolor: "#f3f4f6" },
//                     }}
//                   >
//                     Start Free Trial
//                   </Button>
//                   <Button
//                     variant="outlined"
//                     size="large"
//                     sx={{
//                       px: 4,
//                       py: 1,
//                       color: "white",
//                       borderColor: "white",
//                       "&:hover": {
//                         borderColor: "white",
//                         bgcolor: "rgba(255,255,255,0.1)",
//                       },
//                     }}
//                   >
//                     Schedule Demo
//                   </Button>
//                 </Box>

//                 <Grid container spacing={6} sx={{ mt: 2 }}>
//                   <Grid size={{ xs: 12, md: 4 }}>
//                     <Box sx={{ textAlign: "center" }}>
//                       <Typography variant="h4" fontWeight={700}>
//                         14 Days
//                       </Typography>
//                       <Typography variant="h6" sx={{ opacity: 0.9, mt: 1 }}>
//                         Free Trial
//                       </Typography>
//                     </Box>
//                   </Grid>
//                   <Grid size={{ xs: 12, md: 4 }}>
//                     <Box sx={{ textAlign: "center" }}>
//                       <Typography variant="h4" fontWeight={700}>
//                         No Setup
//                       </Typography>
//                       <Typography variant="h6" sx={{ opacity: 0.9, mt: 1 }}>
//                         Required
//                       </Typography>
//                     </Box>
//                   </Grid>
//                   <Grid size={{ xs: 12, md: 4 }}>
//                     <Box sx={{ textAlign: "center" }}>
//                       <Typography variant="h4" fontWeight={700}>
//                         24/7
//                       </Typography>
//                       <Typography variant="h6" sx={{ opacity: 0.9, mt: 1 }}>
//                         Support
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Box>
//             </Container>
//           </Box>

//           {/* Footer */}
//           <Box sx={{ bgcolor: "#1e293b", color: "white", py: 3 }}>
//             <Container maxWidth="lg">
//               <Grid container spacing={4}>
//                 <Grid size={{ xs: 12, md: 6 }}>
//                   <Typography
//                     variant="h5"
//                     sx={{ fontWeight: 700, fontStyle: "italic", mb: 2 }}
//                   >
//                     Synthium Suite
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{ opacity: 0.8, mb: 1, maxWidth: "400px" }}
//                   >
//                     The operational engine of the Synthium ecosystem—designed
//                     for sales, client services, finance, and operations teams to
//                     execute strategy with speed, clarity, and intelligence.

//                   </Typography>
//                   <Box sx={{ display: "flex", gap: 1 }}>
//                     <IconButton
//                       sx={{
//                         color: "white",
//                         "&:hover": {
//                           color: "#1DA1F2", 
//                           backgroundColor: "rgba(29, 161, 242, 0.1)",
//                         },
//                       }}
//                       size="small"
//                       onClick={() =>
//                         window.open("https://twitter.com", "_blank")
//                       }
//                     >
//                       <Twitter />
//                     </IconButton>
//                     <IconButton
//                       sx={{
//                         color: "white",
//                         "&:hover": {
//                           color: "#0077B5",
//                           backgroundColor: "rgba(0, 119, 181, 0.1)",
//                         },
//                       }}
//                       size="small"
//                       onClick={() =>
//                         window.open("https://linkedin.com", "_blank")
//                       }
//                     >
//                       <LinkedIn />
//                     </IconButton>
//                     <IconButton
//                       sx={{
//                         color: "white",
//                         "&:hover": {
//                           color: "#f5f5f5",
//                           backgroundColor: "rgba(255, 255, 255, 0.1)",
//                         },
//                       }}
//                       size="small"
//                       onClick={() =>
//                         window.open("https://github.com", "_blank")
//                       }
//                     >
//                       <GitHub />
//                     </IconButton>
//                   </Box>
//                 </Grid>
//                 <Grid size={{ xs: 6, md: 3 }}>
//                   <Typography variant="h6" gutterBottom fontWeight={600}>
//                     Product
//                   </Typography>
//                   <Box
//                     sx={{ display: "flex", flexDirection: "column", gap: 1 }}
//                   >
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         opacity: 0.8,
//                         cursor: "pointer",
//                         "&:hover": { opacity: 1 },
//                       }}
//                       onClick={() => scrollToSection("features")}
//                     >
//                      <bold>Features</bold> 
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         opacity: 0.8,
//                         cursor: "pointer",
//                         "&:hover": { opacity: 1 },
//                       }}
//                       onClick={() => scrollToSection("modules")}
//                     >
//                       Modules
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         opacity: 0.8,
//                         cursor: "pointer",
//                         "&:hover": { opacity: 1 },
//                       }}
//                       onClick={() => scrollToSection("Products")}
//                     >
//                       Products
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         opacity: 0.8,
//                         cursor: "pointer",
//                         "&:hover": { opacity: 1 },
//                       }}
//                       onClick={() => scrollToSection("security")}
//                     >
//                       Security
//                     </Typography>
//                   </Box>
//                 </Grid>
//                 <Grid size={{ xs: 6, md: 3 }}>
//                   <Typography variant="h6" gutterBottom fontWeight={600}>
//                     Company
//                   </Typography>
//                   <Box
//                     sx={{ display: "flex", flexDirection: "column", gap: 1 }}
//                   >
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         opacity: 0.8,
//                         cursor: "pointer",
//                         "&:hover": { opacity: 1 },
//                       }}
//                     >
//                       About
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         opacity: 0.8,
//                         cursor: "pointer",
//                         "&:hover": { opacity: 1 },
//                       }}
//                     >
//                       Careers
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         opacity: 0.8,
//                         cursor: "pointer",
//                         "&:hover": { opacity: 1 },
//                       }}
//                     >
//                       Contact
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         opacity: 0.8,
//                         cursor: "pointer",
//                         "&:hover": { opacity: 1 },
//                       }}
//                     >
//                       Support
//                     </Typography>
//                   </Box>
//                 </Grid>
//               </Grid>
//               <Box
//                 sx={{
//                   borderTop: "1px solid rgba(255,255,255,0.1)",
//                   mt: 6,
//                   pt: 4,
//                   textAlign: "center",
//                 }}
//               >
//                 <Typography variant="body2" sx={{ opacity: 0.6 }}>
//                  © {new Date().getFullYear()} Synthium Suite. All rights reserved.
//                 </Typography>
//               </Box>
//             </Container>
//           </Box>

//           <ScrollTop>
//             <Fab
//               size="small"
//               aria-label="scroll back to top"
//               sx={{ bgcolor: "#2563eb", color: "white" }}
//             >
//               <KeyboardArrowUp />
//             </Fab>
//           </ScrollTop>
//         </Box>
//       </ThemeProvider>
//     </>
//   );
// }







// import React from "react";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   Container,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   IconButton,
//   ThemeProvider,
//   createTheme,
//   CssBaseline,
//   Chip,
//   useScrollTrigger,
//   Fab,
//   Zoom,
// } from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid2";

// // Local images provided by the user (local paths will be transformed by the environment)
//  import Bg_Image from "../src/assets/Bg_Image/bg_image.jpg";
// import fav from "../src/assets/logo192.png";

// import {
//   PlayArrow,
//   Psychology,
//   People,
//   Link as LinkIcon,
//   Security,
//   Insights,
//   ViewModule,
//   TrendingUp,
//   Groups,
//   Description,
//   Task,
//   Receipt,
//   Web,
//   Business,
//   Gavel,
//   Palette,
//   Shield,
//   Code,
//   Lock,
//   SupervisedUserCircle,
//   Twitter,
//   LinkedIn,
//   GitHub,
//   KeyboardArrowUp,
//   HealthAndSafety,
//   Agriculture,
//   Garage,
// } from "@mui/icons-material";
// import { Link, useNavigate } from "react-router-dom";
// import { Mail } from "lucide-react";

// const theme = createTheme({
//   palette: {
//     primary: { main: "#2563eb" },
//     secondary: { main: "#1e293b" },
//   },
//   typography: {
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     h1: { fontWeight: 700, fontSize: "3.2rem" },
//     h2: { fontWeight: 700, fontSize: "2.2rem" },
//     h4: { fontWeight: 600 },
//   },
// });

// function ScrollTop(props) {
//   const { children, window } = props;
//   const trigger = useScrollTrigger({
//     target: window ? window() : undefined,
//     disableHysteresis: true,
//     threshold: 100,
//   });

//   const handleClick = (event) => {
//     const anchor = (event.target.ownerDocument || document).querySelector(
//       "#back-to-top-anchor"
//     );
//     if (anchor) {
//       anchor.scrollIntoView({ block: "center", behavior: "smooth" });
//     }
//   };

//   return (
//     <Zoom in={trigger}>
//       <Box onClick={handleClick} role="presentation" sx={{ position: "fixed", bottom: 16, right: 16 }}>
//         {children}
//       </Box>
//     </Zoom>
//   );
// }

// export default function SynthiumLanding() {
//   const navigate = useNavigate();

//   const scrollToSection = (sectionId) => {
//     navigate(`#${sectionId}`);
//     setTimeout(() => {
//       const element = document.getElementById(sectionId);
//       if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
//     }, 100);
//   };

//   // --- Data arrays retained (no functionality changed) ---
//   const securityFeatures = [
//     { icon: Lock, title: "End-to-End Encryption", description: "AES-256 encryption with HSM key rotation ensures your data is always protected." },
//     { icon: Security, title: "Compliance Ready", description: "GDPR, HIPAA, SOC 2, and CCPA ready with automated compliance reporting." },
//     { icon: Description, title: "Immutable Audit Logs", description: "Complete audit trails via Synthium Secure's AuditChain for full transparency." },
//     { icon: SupervisedUserCircle, title: "Granular Access Control", description: "Role-based access control with granular sharing for internal and external collaborators." },
//   ];

//   const features = [
//     { icon: Psychology, title: "AI-Enhanced Intelligence", description: "AI suggests next steps, analyzes deal health, and provides actionable insights that empower your team without overwhelming them." },
//     { icon: People, title: "Human-Centered Design", description: "Intuitive interface designed for real people doing real work. Get productive from day one with minimal training required." },
//     { icon: LinkIcon, title: "Seamless Integration", description: "Connects to all Synthium Suites and external tools like Salesforce, QuickBooks, M365, and more for unified workflows." },
//     { icon: Security, title: "Enterprise Security", description: "End-to-end AES-256 encryption, GDPR/HIPAA compliance, and immutable audit trails without complexity." },
//     { icon: Insights, title: "Real-Time Insights", description: "Live key real-time critical information about deal health, workload distribution, and team performance." },
//     { icon: ViewModule, title: "Fully Modular", description: "Start with Deals, Docs, scale to end-to-end client lifecycle orchestration. Pay only for what you use." },
//   ];

//   const modules = [
//     { icon: TrendingUp, title: "Deals", description: "AI-guided sales pipeline with risk forecasting, deal scoring, and automated next-step recommendations.", chips: ["Pipeline Management","Risk Forecasting","Deal Scoring","Revenue Predictions"] },
//     { icon: Groups, title: "Client 360", description: "Unified workspace for contacts, communications, and complete client history with sentiment analysis.", chips: ["Contact Management","Communication History","Sentiment Analysis","Relationship Mapping"] },
//     { icon: Description, title: "Docs", description: "Real-time collaborative documents with e-signature and Legal Suite compliance checks.", chips: ["Real-time Collaboration","E-signature Integration","Compliance Checks","Version Control"] },
//     { icon: Task, title: "Tasks", description: "Smart, auto-generated actions linked to contacts, meetings, and client milestones.", chips: ["Auto-generation","Meeting Integration","Contract Linking","Progress Tracking"] },
//     { icon: Receipt, title: "Invoices", description: "Automated billing synced to contracts and ERP systems with payment tracking.", chips: ["Automated Billing","ERP Integration","Payment Tracking","Revenue Recognition"] },
//     { icon: Web, title: "Portal", description: "Secure client-facing hub for approvals, payments, feedback, and project collaboration.", chips: ["Client Access","Approval Workflows","Payment Processing","Feedback Collection"] },
//   ];

//   const Products = [
//     { icon: Business, title: "Enterprise Suite", description: "Shares KPIs, forecasts, and compliance data for strategic decision-making." },
//     { icon: Gavel, title: "Legal Suite", description: "Validates contracts and flags risks with automated compliance checks." },
//     { icon: Palette, title: "Creative Suite", description: "Ties campaigns to client ROI and tracks creative project performance.", link: "https://sythiumsuites.com/" },
//     { icon: Code, title: "Business Suite", description: "Ties campaigns to Business Professional for contracts and tracks creative RFP's and Proposals.", link: "https://contractpro360.com" },
//     { icon: Shield, title: "Secure Suite", description: "Enforces encryption, RBAC, and maintains immutable audit trails." },
//     { icon: Code, title: "Developer Suite", description: "Tracks API usage and manages client Products seamlessly." },
//     { icon: HealthAndSafety, title: "Health Suite", description: "Cares about the lives with integrity of emergency SOS and nearby networking hospitals for easy access." },
//       { icon: Agriculture, title: "Agriculture Suite", description: "Provide basic and necessary Details and updates for agricultural resources from small home farming to large sector farming land with herd, flock, warren" },
//       { icon: Garage, title: "Auto Garage Suite", description: "rofessional Mechanic's from auto repair workshops which include service station availability which says car surgeons." },
//     ];

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />

//       <Box sx={{ flexGrow: 1 }}>
//         {/* Navigation */}
//         <AppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: "1px solid #e6eefc" }}>
//           <Toolbar sx={{ gap: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexGrow: 1 }}>
//               <img src={fav} alt="logo" style={{ width: "10%"}} />
//               <Typography
//   variant="h5"
//   sx={{
//     flexGrow: 1,
//     fontWeight: 800,
//     color: "#000",
//     display: "flex",
//     alignItems: "center",   // vertically center logo + text
//     gap: "10px",            // spacing between logo and name
//     fontSize: "34px",  
//   }}
// >

//   <span>Synthium Suite</span>
// </Typography>
//             </Box>

//             <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 1 }}>
//               {["features","modules","Products","security"].map((s) => (
//                 <Button key={s} onClick={() => scrollToSection(s)} color="inherit" sx={{ fontWeight: 600, fontSize: 15 }}>
//                   {s.toUpperCase()}
//                 </Button>
//               ))}
//               <Button variant="contained" sx={{ ml: 2 }} onClick={() => window.open("https://sythiumsuites.com", "_blank")}>Get Started</Button>
//             </Box>
//           </Toolbar>
//         </AppBar>

//         {/* Hero */}
//         <Box sx={{ backgroundImage: `url(${Bg_Image})`, backgroundSize: "cover", 
//         backgroundPosition: "center", color: "white", py: { xs: 8, md: 12 }, minHeight: 700, display: "flex", alignItems: "center" }}>
//           <Container maxWidth="lg">
//             <Box sx={{ textAlign: "center", backdropFilter: "blur(0px)", px: { xs: 2, md: 6 } }}>
//               <Typography variant="h1" sx={{ color: "rgba(255,255,255,0.97)", fontSize: { xs: "3rem", md: "3.2rem" }, lineHeight: 1.05 }}>
//                 Where Work Gets Done — <Box component="span" sx={{ display: "block", fontWeight: 800 }}>Together</Box>
//               </Typography>

//               <Typography variant="body1" sx={{ mt: 3, maxWidth: 820, mx: "auto", opacity: 0.95, fontSize: { xs: "1.5rem" , md: 16 } }}>
//                 The operational engine of the Synthium ecosystem—designed for sales, client services, finance, and operations teams to execute strategy with speed, clarity, and intelligence.
//               </Typography>

//               <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 4 }}>
//                 <Button variant="contained" size="large" sx={{ px: 4, py: 1.25 }}  onClick={() => window.open("https://sythiumsuites.com", "_blank")}>Start Free Trial</Button>
//                 <Button variant="outlined" size="large" startIcon={<PlayArrow />} sx={{ color: "white", borderColor: "rgba(255,255,255,0.6)", '&:hover': { bgcolor: 'rgba(255,255,255,0.06)' } }}>Watch Demo</Button>
//               </Box>
//             </Box>
//           </Container>
//         </Box>

//         {/* Features */}
//         <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 } }} id="features">
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Typography variant="h2" sx={{ fontWeight: 800, fontSize: { xs: '1.6rem', md: '2.2rem' } }}>Built for How
//                You Actually Work</Typography>
//             <Typography color="text.secondary" sx={{ maxWidth: 720, mx: 'auto', mt: 2 }}>Every feature designed to turn everyday tasks into structured, secure, and AI-enhanced workflows that feed real-time insight back into your enterprise strategy.</Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {features.map((feature, i) => (
//               <Grid key={i} xs={12} sm={6} md={4}>
//                 <Card sx={{ height: '100%', borderRadius: 2, p: 2, boxShadow: '0 6px 18px rgba(22,28,45,0.04)', transition: 'transform .25s ease', '&:hover': { transform: 'translateY(-6px)' } }}>
//                   <CardContent>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                       <Box sx={{ bgcolor: '#f1f9ff', p: 1.25, borderRadius: 2, display: 'inline-flex' }}>
//                         <feature.icon sx={{ color: '#2563eb', fontSize: 30 }} />
//                       </Box>
//                       <Typography variant="h6" sx={{ fontWeight: 800 }}>{feature.title}</Typography>
//                     </Box>
//                     <Typography color="text.secondary" sx={{ mt: 2.0, fontSize: 14 }}>{feature.description}</Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>

//         {/* Modules */}
//         <Box sx={{ bgcolor: '#fbfdff', py: { xs: 4, md: 8 } }} id="modules">
//           <Container maxWidth="lg">
//             <Box sx={{ textAlign: 'center', mb: 4 }}>
//               <Typography variant="h2" sx={{ fontWeight: 800 }}>Many Powerful Modules,
                
//                One Unified Experience</Typography>
//               <Typography color="text.secondary" sx={{ mt: 1 }}>Each module is designed
//                  to work independently or together, creating a seamless workflow from first contact to final invoice.</Typography>
//             </Box>

//             <Grid container spacing={3}>
//               {modules.map((module, idx) => (
//                 <Grid key={idx} xs={12} md={6}>
//                   <Card sx={{ display: 'flex', gap: 2, alignItems: 'stretch', p: 2, borderRadius: 2, boxShadow: '0 8px 24px rgba(22,28,45,0.04)' }}>
//                     <Box sx={{ bgcolor: '#2563eb', p: 1.5, borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: 72 }}>
//                       <module.icon sx={{ color: 'white', fontSize: 28 }} />
//                     </Box>
//                     <Box sx={{ flex: 1 }}>
//                       <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 18 }}>{module.title}</Typography>
//                       <Typography color="text.secondary" sx={{ mt: 1, mb: 1 }}>{module.description}</Typography>
//                       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
//                         {module.chips.map((c, ci) => (
//                           <Chip key={ci} label={c} size="small" sx={{ bgcolor: '#eff6ff', color: '#5c7adeff', fontWeight: 600 }} />
//                         ))}
//                       </Box>
//                     </Box>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           </Container>
//         </Box>

//         {/* Products */}
//         <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 } }} id="Products">
//           <Box sx={{ textAlign: 'center', mb: 4 }}>
//             <Typography variant="h2" sx={{ fontWeight: 800 }}>Seamlessly Connected Ecosystem</Typography>
//             <Typography color="text.secondary" sx={{ mt: 1 }}>Built on Synthium Core with real-time bi-directional integration across all Synthium Suites and your favorite external tools.</Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {Products.map((it, i) => (
//               <Grid key={i} xs={12} sm={6} md={4}>
//                 <Card sx={{ textAlign: 'center', p: 3, borderRadius: 2, boxShadow: '0 6px 18px rgba(22,28,45,0.04)', transition: 'transform .2s ease', '&:hover': { transform: 'translateY(-6px)' } }}>
//                   <Box sx={{ bgcolor: '#f1fbff', p: 2, display: 'inline-flex', borderRadius: 2, mb: 2 }}>
//                     <it.icon sx={{ color: '#2563eb', fontSize: 40 }} />
//                   </Box>
//                   <Typography variant="h6" sx={{ fontWeight: 700 }}>{it.link ? <a href={it.link} target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>{it.title}</a> : it.title}</Typography>
//                   <Typography color="text.secondary" sx={{ mt: 1 }}>{it.description}</Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>

//         {/* Security */}
//         <Box sx={{ bgcolor: '#fff', py: { xs: 4, md: 8 } }} id="security">
//           <Container maxWidth="lg">
//             <Box sx={{ textAlign: 'center', mb: 4 }}>
//               <Typography variant="h2" sx={{ fontWeight: 800 ,}}>Enterprise-Grade 
//                 Security Without Complexity</Typography>
//               <Typography color="text.secondary" sx={{ maxWidth: 820, mx: 'auto', mt: 1 }}>Built with security at its core, Synthium Business Suite provides enterprise-level protection that's simple to manage and transparent to use.</Typography>
//             </Box>

//             <Grid container spacing={3}>
//               {securityFeatures.map((f, i) => (
//                 <Grid key={i} xs={12} sm={6} md={6}>
//                   <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
//                     <Box sx={{ bgcolor: '#2563eb', p: 1.25, borderRadius: 2, minWidth: 48, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                       <f.icon sx={{ color: 'white' }} />
//                     </Box>
//                     <Box>
//                       <Typography sx={{ fontWeight: 700 }}>{f.title}</Typography>
//                       <Typography color="text.secondary" sx={{ mt: 1 }}>{f.description}</Typography>
//                     </Box>
//                   </Box>
//                 </Grid>
//               ))}
//             </Grid>
//           </Container>
//         </Box>

//         {/* CTA */}
//         <Box sx={{ bgcolor: '#588cfdff', color: 'white', py: { xs: 4, md: 8 } }}>
//           <Container maxWidth="md" sx={{ textAlign: 'center' }}>
//             <Typography variant="h4" sx={{ fontWeight: 800 }}>Ready to Transform Your Business Operations?</Typography>
//             <Typography sx={{ mt: 1.5, opacity: 0.95 }}>Join thousands of teams who have streamlined their workflows with Synthium Business Suite. Start with a free trial and see the difference AI-enhanced operations can make.</Typography>
//             <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3 }}>
//               <Button variant="contained" size="large" sx={{ px: 4, bgcolor: 'white', color: '#2563eb', '&:hover': { bgcolor: '#f3f4f6'} }}  onClick={() => window.open("https://sythiumsuites.com", "_blank")}>Start Free Trial</Button>
//               <Button variant="outlined" size="large" sx={{ px: 4, color: 'white', borderColor: 'white' }}>Schedule Demo</Button>
//             </Box>

//             <Grid container spacing={4} sx={{ mt: 4 }}>
//               <Grid xs={12} md={4}>
//                 <Typography variant="h4" sx={{ fontWeight: 800 }}>14 Days</Typography>
//                 <Typography>Free Trial</Typography>
//               </Grid>
//               <Grid xs={12} md={4}>
//                 <Typography variant="h4" sx={{ fontWeight: 800 }}>No Setup</Typography>
//                 <Typography>Required</Typography>
//               </Grid>
//               <Grid xs={12} md={4}>
//                 <Typography variant="h4" sx={{ fontWeight: 800 }}>24/7</Typography>
//                 <Typography>Support</Typography>
//               </Grid>
//             </Grid>
//           </Container>
//         </Box>

//         {/* Footer */}
//         <Box sx={{ bgcolor: '#1e293b', color: 'white', py: 4 }}>
//           <Container maxWidth="lg">
//             <Grid container spacing={4}>
//               <Grid xs={12} md={6}>
//                 <Typography variant="h5" sx={{ fontWeight: 800, fontStyle: 'Bold', mb: 2 }}>Synthium Suite</Typography>
//                 <Typography color="text.secondary" sx={{ opacity: 0.85, maxWidth: 480 , color: '#ffffffff'}}>The operational engine of th
//                   e Synthium ecosystem—designed for sales, client services, finance, and operations 
//                   teams to execute strategy with speed, clarity, and intelligence.</Typography>
//                 <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
//                   <IconButton size="small" sx={{ color: 'white' }} onClick={() => window.open('https://twitter.com','_blank')}><Twitter /></IconButton>
//                   <IconButton size="small" sx={{ color: 'white' }} onClick={() => window.open('https://linkedin.com','_blank')}><LinkedIn /></IconButton>
//                   <IconButton size="small" sx={{ color: 'white' }} onClick={() => window.open('https://github.com','_blank')}><GitHub /></IconButton>
//                   <IconButton size="small" sx={{ color: 'white' }} onClick={() => window.open('https://gmail.com','admin@synthiumsuite.com')}><Mail /></IconButton>
//                 </Box>
//               </Grid>

//               <Grid xs={6} md={3}>
//                 <Typography variant="h6" sx={{ fontWeight: 700 }}>Product</Typography>
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
//                   <Button onClick={() => scrollToSection('features')} sx={{ justifyContent: 'flex-start', color: 'rgba(255,255,255,0.85)' }}>Features</Button>
//                   <Button onClick={() => scrollToSection('modules')} sx={{ justifyContent: 'flex-start', color: 'rgba(255,255,255,0.85)' }}>Modules</Button>
//                   <Button onClick={() => scrollToSection('Products')} sx={{ justifyContent: 'flex-start', color: 'rgba(255,255,255,0.85)' }}>Products</Button>
//                   <Button onClick={() => scrollToSection('security')} sx={{ justifyContent: 'flex-start', color: 'rgba(255,255,255,0.85)' }}>Security</Button>
//                 </Box>
//               </Grid>

//               <Grid xs={6} md={3}>
//                 <Typography variant="h6" sx={{ fontWeight: 700 }}>Company</Typography>
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
//                   <Typography color="rgba(255,255,255,0.85)">About</Typography>
//                   <Typography color="rgba(255,255,255,0.85)">Careers</Typography>
//                   <Typography color="rgba(255,255,255,0.85)">Contact</Typography>
//                   <Typography color="rgba(255,255,255,0.85)">Support</Typography>
//                 </Box>
//               </Grid>
//             </Grid>

//             <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.06)', mt: 6, pt: 3, textAlign: 'center' }}>
//               <Typography color="rgba(255,255,255,0.65)">© {new Date().getFullYear()} Synthium Suite. All rights reserved.</Typography>
//             </Box>
//           </Container>
//         </Box>

//         <ScrollTop>
//           <Fab size="small" aria-label="scroll back to top" sx={{ bgcolor: '#2563eb', color: 'white' }}>
//             <KeyboardArrowUp />
//           </Fab>
//         </ScrollTop>
//       </Box>
//     </ThemeProvider>
//   );
// }



import React from "react";
import {
  AppBar, Toolbar, Button, Container, Typography, Box, Card, CardContent,
  IconButton, ThemeProvider, createTheme, CssBaseline, Chip, useScrollTrigger,
  Fab, Zoom, alpha, Fade, Slide,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import Bg_Image from './assets/Bg_Image/bg_image.jpg';
import {
  PlayArrow, Psychology, People, Link as LinkIcon, Security, Insights, ViewModule,
  TrendingUp, Groups, Description, Task, Receipt, Web, Business, Gavel, Palette,
  Shield, Code, Lock, SupervisedUserCircle, Twitter, LinkedIn, GitHub,
  KeyboardArrowUp, ArrowForward, Star,LocationOn,LocalPhone,Email,
  HealthAndSafety,
  Agriculture,
  Garage,
} from "@mui/icons-material";
import fav from "../src/assets/logo192.png";
import { useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";

const theme = createTheme({
  palette: {
    primary: { main: "#667eea", dark: "#5568d3", light: "#7e8ff5" },
    secondary: { main: "#764ba2", dark: "#5d3981", light: "#9368b8" },
    background: { default: "#f8f9fa", paper: "#ffffff" },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 800, fontSize: "3.5rem", letterSpacing: "-0.02em" },
    h2: { fontWeight: 800, fontSize: "2.75rem", letterSpacing: "-0.02em" },
    h4: { fontWeight: 700, letterSpacing: "-0.01em" },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 16 },
});

function ScrollTop(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window ? window() : undefined, disableHysteresis: true, threshold: 100 });
  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector("#back-to-top-anchor");
    if (anchor) anchor.scrollIntoView({ block: "center", behavior: "smooth" });
  };
  return (
    <Zoom in={trigger}>
      <Box onClick={handleClick} role="presentation" sx={{ position: "fixed", bottom: 24, right: 24, zIndex: 1000 }}>
        {children}
      </Box>
    </Zoom>
  );
}

export default function SynthiumLanding() {
  const navigate = useNavigate();
  const scrollToSection = (sectionId) => {
    navigate(`#${sectionId}`);
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  const securityFeatures = [
    { icon: Lock, title: "End-to-End Encryption", description: "AES-256 encryption with HSM key rotation ensures your data is always protected." },
    { icon: Security, title: "Compliance Ready", description: "GDPR, HIPAA, SOC 2, and CCPA ready with automated compliance reporting." },
    { icon: Description, title: "Immutable Audit Logs", description: "Complete audit trails via Synthium Secure's AuditChain for full transparency." },
    { icon: SupervisedUserCircle, title: "Granular Access Control", description: "Role-based access control with granular sharing for internal and external collaborators." },
  ];

  const features = [
    { icon: Psychology, title: "AI-Enhanced Intelligence", description: "AI suggests next steps, analyzes deal health, and provides actionable insights that empower your team without overwhelming them.", color: "#667eea" },
    { icon: People, title: "Human-Centered Design", description: "Intuitive interface designed for real people doing real work. Get productive from day one with minimal training required.", color: "#764ba2" },
    { icon: LinkIcon, title: "Seamless Integration", description: "Connects to all Synthium Suites and external tools like Salesforce, QuickBooks, M365, and more for unified workflows.", color: "#f093fb" },
    { icon: Security, title: "Enterprise Security", description: "End-to-end AES-256 encryption, GDPR/HIPAA compliance, and immutable audit trails without complexity.", color: "#4facfe" },
    { icon: Insights, title: "Real-Time Insights", description: "Live key real-time critical information about deal health, workload distribution, and team performance.", color: "#43e97b" },
    { icon: ViewModule, title: "Fully Modular", description: "Start with Deals, Docs, scale to end-to-end client lifecycle orchestration. Pay only for what you use.", color: "#fa709a" },
  ];

  const modules = [
    { icon: TrendingUp, title: "Deals", description: "AI-guided sales pipeline with risk forecasting, deal scoring, and automated next-step recommendations.", chips: ["Pipeline Management", "Risk Forecasting", "Deal Scoring", "Revenue Predictions"], gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" },
    { icon: Groups, title: "Client 360", description: "Unified workspace for contacts, communications, and complete client history with sentiment analysis.", chips: ["Contact Management", "Communication History", "Sentiment Analysis", "Relationship Mapping"], gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" },
    { icon: Description, title: "Docs", description: "Real-time collaborative documents with e-signature and Legal Suite compliance checks.", chips: ["Real-time Collaboration", "E-signature Integration", "Compliance Checks", "Version Control"], gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)" },
    { icon: Task, title: "Tasks", description: "Smart, auto-generated actions linked to contacts, meetings, and client milestones.", chips: ["Auto-generation", "Meeting Integration", "Contract Linking", "Progress Tracking"], gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)" },
    { icon: Receipt, title: "Invoices", description: "Automated billing synced to contracts and ERP systems with payment tracking.", chips: ["Automated Billing", "ERP Integration", "Payment Tracking", "Revenue Recognition"], gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)" },
    { icon: Web, title: "Portal", description: "Secure client-facing hub for approvals, payments, feedback, and project collaboration.", chips: ["Client Access", "Approval Workflows", "Payment Processing", "Feedback Collection"], gradient: "linear-gradient(135deg, #30cfd0 0%, #330867 100%)" },
  ];

  const Products = [

     { icon: Palette, title: "Creative Suite", description: "The Creative Intelligence Platform | Everything You Need to Build and Create.", link: "https://synthiumcreativesuite.com/" },
    { icon: Code, title: "Business Suite", description: "Ties campaigns to Business Professional for contracts and tracks creative RFP's and Proposals.", link: "https://contractpro360.com" },
    { icon: Business, title: "Enterprise Suite", description: "Shares KPIs, forecasts, and compliance data for strategic decision-making." },
    { icon: Gavel, title: "Legal Suite", description: "Validates contracts and flags risks with automated compliance checks." },
    { icon: Shield, title: "Secure Suite", description: "Enforces encryption, RBAC, and maintains immutable audit trails." },
    { icon: Code, title: "Developer Suite", description: "Tracks API usage and manages client Products seamlessly." },
     { icon: HealthAndSafety, title: "Health Suite", description: "Cares about the lives with integrity of emergency SOS and nearby networking hospitals for easy access." },
     { icon: Agriculture, title: "Agriculture Suite", description: "Provide basic and necessary Details and updates for agricultural resources from small home farming to large sector farming land with herd, flock, warren" },
     { icon: Garage, title: "Auto Garage Suite", description: "Professional Mechanic's from auto repair workshops which include service station availability which says car surgeons." },

  ]
  
  ;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ flexGrow: 1, background: "#ffffff" }} id="back-to-top-anchor">
        {/* Navigation */}
        <AppBar position="sticky" elevation={0} sx={{ background: "rgba(255, 255, 255, 0.95)", backdropFilter: "blur(20px)", borderBottom: "1px solid rgba(102, 126, 234, 0.1)", transition: "all 0.3s ease" }}>
          <Toolbar sx={{ py: 1 }}>
            <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box component="img" src={fav} sx={{ width: "10%",  transition: "transform 0.3s ease", "&:hover": { transform: "scale(1.1) rotate(5deg)" } }} />
              <Typography variant="h5" sx={{ fontWeight: 800,fontSize: "34px",background: "linear-gradient(135deg, #0b0b0cff 0%, #0b0b0cff 100%)", backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
            <span>Synthium Suite</span>    
              </Typography>
            </Box>

          <Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 3, // equal spacing between items
  }}
>
  {["features", "modules", "products", "security"].map((section) => (
    <Button
      key={section}
      onClick={() => scrollToSection(section)} // <-- RESTORED FUNCTIONALITY
      sx={{
        fontSize: { xs: "12px", sm: "14px", md: "16px" },
        color: "#1e293b",
        fontWeight: 500,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        position: "relative",
        background: "transparent",
        whiteSpace: "nowrap",

        "&:after": {
          content: '""',
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderRadius: "2px 2px 0 0",
          transition: "width 0.3s ease",
        },

        "&:hover": {
          "&:after": { width: "100%" },
        },
      }}
    >
      {section}
    </Button>
  ))}

  {/* CTA BUTTON */}
  <Button
    variant="contained"
    endIcon={<ArrowForward />}
    sx={{
      px: 3,
      py: 1,
      borderRadius: 50,
      ml: 1,
      fontWeight: 600,
      fontSize: { xs: "12px", sm: "14px", md: "16px" },
      whiteSpace: "nowrap",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      boxShadow: "0 4px 16px rgba(102, 126, 234, 0.3)",
      transition: "all 0.3s ease",

      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 6px 24px rgba(102, 126, 234, 0.4)",
      },
    }}
    onClick={() => window.open("https://synthiumcreativesuite.com", "_blank")}
  >
    Get Started
  </Button>
</Box>


            {/* {["features", "modules", "Products", "security"].map((section) => (
              <Button key={section} sx={{ mx: 1, fontWeight: 500, fontSize: "18px", 
              color: "#1e293b", textTransform: "uppercase", letterSpacing: "0.5px", 
              position: "relative", "&:after": { content: '""', position: "absolute",
               bottom: 0, left: "50%", transform: "translateX(-50%)",
               width: 0, height: 3, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "2px 2px 0 0", transition: "width 0.3s ease" }, 
                "&:hover": { background: "transparent", "&:after": { width: "100%" } } }} 
                onClick={() => scrollToSection(section)}>
                {section}
              </Button>
            ))}
            <Button variant="contained" endIcon={<ArrowForward />} 
            sx={{ ml: 2, background: "linear-gradient(135deg, #667eea 0%,)", 
            borderRadius: 50, px: 3, py: 1, fontWeight: 600, textTransform: "none",
             boxShadow: "0 4px 16px rgba(102, 126, 234, 0.3)", transition: "all 0.3s ease", 
             "&:hover": { transform: "translateY(-2px)", boxShadow: "0 6px 24px rgba(102, 126, 234, 0.4)" } }} onClick={() => window.open("https://synthiumcreativesuite.com", "_blank")}>
              Get Started
            </Button> */}
          </Toolbar>
        </AppBar>

        {/* Hero Section */}
        <Box sx={{ position: "relative", backgroundImage: `url(${Bg_Image})`, backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed", minHeight: "90vh", display: "flex", alignItems: "center", overflow: "hidden", "&:before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "linear-gradient(135deg, rgba(102, 126, 234, 0.85) 0%,)", zIndex: 1 } }}>
          <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
            <Fade in timeout={1000}>
              <Box sx={{ textAlign: "center", color: "white" }}>
                <Chip icon={<Star sx={{ color: "white !important" }} />} label="Trusted by 10,000+ Teams Worldwide" sx={{ mb: 3, bgcolor: alpha("#ffffff", 0.2), color: "white", fontWeight: 600, backdropFilter: "blur(10px)", border: "1px solid rgba(255, 255, 255, 0.3)" }} />
                <Typography variant="h1" gutterBottom sx={{ color: "white", fontSize: { xs: "2.5rem", md: "4rem" }, mb: 2,
                 textShadow: "0 4px 20px rgba(0, 0, 0, 0.2)" }}>
                  Where Work Gets Done —<br />
                  <Box component="span" sx={{ background: "linear-gradient(90deg, #ffffff 0%, #f0f0f0 100%)", backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Together</Box>
                </Typography>
                <Typography variant="h5" sx={{ mt: 3, mb: 5, maxWidth: "800px", mx: "auto", opacity: 0.95, fontWeight: 400, lineHeight: 1.6, fontSize: { xs: "1.1rem", md: "1.3rem" } }}>
                  The operational engine of the Synthium ecosystem—designed for sales, client services, finance, and operations teams to execute strategy with speed, clarity, and intelligence.
                </Typography>
                <Box sx={{ display: "flex", gap: 3, justifyContent: "center", flexWrap: "wrap" }}>
                <Button
  variant="contained"
  size="large"
  endIcon={<ArrowForward />}
  onClick={() =>
    window.open("https://synthiumcreativesuite.com", "_blank", "noopener,noreferrer")
  }
  sx={{
    px: 5,
    py: 2,
    fontSize: "1.1rem",
    background: "white",
    color: "#667eea",
    borderRadius: 50,
    fontWeight: 700,
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
    "&:hover": {
      background: "#f8f9fa",
      transform: "translateY(-4px)",
      boxShadow: "0 12px 48px rgba(0, 0, 0, 0.3)"
    },
    transition: "all 0.3s ease"
  }}
>
  Start Free Trial
</Button>
                  <Button variant="outlined" size="large" startIcon={<PlayArrow />} sx={{ px: 5, py: 2, fontSize: "1.1rem", color: "white", borderColor: "white", borderWidth: 2, borderRadius: 50, fontWeight: 700, backdropFilter: "blur(10px)", background: alpha("#ffffff", 0.1), "&:hover": { borderColor: "white", borderWidth: 2, background: alpha("#ffffff", 0.2), transform: "translateY(-4px)" }, transition: "all 0.3s ease" }}>
                    Watch Demo
                  </Button>
                </Box>
              </Box>
            </Fade>
          </Container>
          <Box sx={{ position: "absolute", bottom: -50, left: 0, right: 0, height: 100, background: "white", clipPath: "polygon(0 50%, 100% 0, 100% 100%, 0 100%)", zIndex: 2 }} />
        </Box>

        {/* Features Section */}
        <Container maxWidth="lg" sx={{ py: 12 }} id="features">
          <Fade in timeout={800}>
            <Box sx={{ textAlign: "center", mb: 8 }}>
              <Typography variant="h2" gutterBottom sx={{ fontSize: { xs: "2rem", md: "3rem" }, mb: 2, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                Built for How You Actually Work
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{ maxWidth: "700px", mx: "auto", lineHeight: 1.7, fontWeight: 400 }}>
                Every feature designed to turn everyday tasks into structured, secure, and AI-enhanced workflows that feed real-time insight back into your enterprise strategy.
              </Typography>
            </Box>
          </Fade>
          <Grid2 container spacing={4}>
            {features.map((feature, index) => (
              <Grid2 key={index} xs={12} sm={6} md={4}>
                <Zoom in timeout={400 + index * 100}>
                  <Card sx={{ height: "100%", borderRadius: 4, border: "1px solid", borderColor: alpha(feature.color, 0.1), transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)", position: "relative", overflow: "hidden", "&:before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, height: 4, background: `linear-gradient(90deg, ${feature.color} 0%, ${alpha(feature.color, 0.6)} 100%)` }, "&:hover": { transform: "translateY(-12px)", boxShadow: `0 20px 40px ${alpha(feature.color, 0.2)}`, borderColor: alpha(feature.color, 0.3) } }}>
                    <CardContent sx={{ p: 4 }}>
                      <Box sx={{ bgcolor: alpha(feature.color, 0.1), borderRadius: 3, p: 2, display: "inline-flex", mb: 3, transition: "transform 0.3s ease", "&:hover": { transform: "scale(1.1) rotate(5deg)" } }}>
                        <feature.icon sx={{ color: feature.color, fontSize: 36 }} />
                      </Box>
                      <Typography variant="h5" gutterBottom fontWeight={700} sx={{ mb: 2 }}>{feature.title}</Typography>
                      <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>{feature.description}</Typography>
                    </CardContent>
                  </Card>
                </Zoom>
              </Grid2>
            ))}
          </Grid2>
        </Container>

        {/* Modules Section */}
        <Box sx={{ background: "linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)", py: 12 }} id="modules">
          <Container maxWidth="lg">
            <Fade in timeout={800}>
              <Box sx={{ textAlign: "center", mb: 8 }}>
                <Typography variant="h2" gutterBottom sx={{ fontSize: { xs: "2rem", md: "3rem" }, mb: 2, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                  Many Powerful Modules, One Unified Experience
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400, lineHeight: 1.7 }}>
                  Each module is designed to work independently or together, creating a seamless workflow from first contact to final invoice.
                </Typography>
              </Box>
            </Fade>
            <Grid2 container spacing={4}>
              {modules.map((module, index) => (
                <Grid2 key={index} xs={12} md={6}>
                  <Slide direction="up" in timeout={500 + index * 100}>
                    <Card sx={{ height: "100%", borderRadius: 4, transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)", position: "relative", overflow: "hidden", "&:before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, height: 6, background: module.gradient }, "&:hover": { transform: "translateY(-8px)", boxShadow: "0 20px 40px rgba(102, 126, 234, 0.15)" } }}>
                      <CardContent sx={{ p: 4 }}>
                        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                          <Box sx={{ background: module.gradient, borderRadius: 3, p: 2, mr: 2, display: "flex", boxShadow: "0 8px 24px rgba(102, 126, 234, 0.2)" }}>
                            <module.icon sx={{ color: "white", fontSize: 32 }} />
                          </Box>
                          <Typography variant="h4" fontWeight={700}>{module.title}</Typography>
                        </Box>
                        <Typography variant="body1" color="text.secondary" paragraph sx={{ lineHeight: 1.7, mb: 3 }}>{module.description}</Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                          {module.chips.map((chip, chipIndex) => (
                            <Chip key={chipIndex} label={chip} size="small" sx={{ bgcolor: alpha("#667eea", 0.08), color: "#667eea", fontWeight: 600, borderRadius: 2, "&:hover": { bgcolor: alpha("#667eea", 0.15) } }} />
                          ))}
                        </Box>
                      </CardContent>
                    </Card>
                  </Slide>
                </Grid2>
              ))}
            </Grid2>
          </Container>
        </Box>

        {/* Products Section */}
        <Container maxWidth="lg" sx={{ py: 12 }} id="Products">
          <Fade in timeout={800}>
            <Box sx={{ textAlign: "center", mb: 8 }}>
              <Typography variant="h2" gutterBottom sx={{ fontSize: { xs: "2rem", md: "3rem" }, mb: 2, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                Seamlessly Connected Ecosystem
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400, lineHeight: 1.7 }}>
                Built on Synthium Core with real-time bi-directional integration across all Synthium Suites and your favorite external tools.
              </Typography>
            </Box>
          </Fade>
          <Grid2 container spacing={4}>
            {Products.map((integration, index) => (
              <Grid2 key={index} xs={12} sm={6} md={4}>
                <Zoom in timeout={400 + index * 100}>
                  <Card sx={{ textAlign: "center", p: 4, height: "100%", borderRadius: 4, border: "1px solid", borderColor: alpha("#667eea", 0.1), transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)", cursor: integration.link ? "pointer" : "default", "&:hover": { transform: "translateY(-8px) scale(1.02)", boxShadow: "0 20px 40px rgba(102, 126, 234, 0.2)", borderColor: alpha("#667eea", 0.3) } }} onClick={() => integration.link && window.open(integration.link, "_blank")}>
                    <Box sx={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", borderRadius: 3, p: 2.5, display: "inline-flex", mb: 3, boxShadow: "0 8px 24px rgba(102, 126, 234, 0.3)" }}>
                      <integration.icon sx={{ color: "white", fontSize: 40 }} />
                    </Box>
                    <Typography variant="h5" fontWeight={700} gutterBottom>{integration.title}</Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>{integration.description}</Typography>
                  </Card>
                </Zoom>
              </Grid2>
            ))}
          </Grid2>
        </Container>

        {/* Security Section */}
        <Box sx={{ background: "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)", py: 12 }} id="security">
          <Container maxWidth="lg">
            <Fade in timeout={800}>
              <Box sx={{ textAlign: "center", mb: 8 }}>
                <Typography variant="h2" gutterBottom sx={{ fontSize: { xs: "2rem", md: "3rem" }, mb: 2, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                  Enterprise-Grade Security Without Complexity
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ maxWidth: "800px", mx: "auto", fontWeight: 400, lineHeight: 1.7 }}>
                  Built with security at its core, Synthium Business Suite provides enterprise-level protection that's simple to manage and transparent to use.
                </Typography>
              </Box>
            </Fade>
            <Grid2 container spacing={4}>
              {securityFeatures.map((feature, index) => (
                <Grid2 key={index} xs={12} sm={6}>
                  <Slide direction="up" in timeout={400 + index * 100}>
                    <Card sx={{ height: "100%", p: 4, borderRadius: 4, border: "1px solid", borderColor: alpha("#667eea", 0.1), transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)", "&:hover": { transform: "translateY(-8px)", boxShadow: "0 20px 40px rgba(102, 126, 234, 0.2)", borderColor: alpha("#667eea", 0.3) } }}>
                      <Box sx={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", borderRadius: 3, p: 2, display: "inline-flex", mb: 3, boxShadow: "0 8px 24px rgba(102, 126, 234, 0.3)" }}>
                        <feature.icon sx={{ color: "white", fontSize: 32 }} />
                      </Box>
                      <Typography variant="h5" gutterBottom fontWeight={700}>{feature.title}</Typography>
                      <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>{feature.description}</Typography>
                    </Card>
                  </Slide>
                </Grid2>
              ))}
            </Grid2>
          </Container>
        </Box>

        {/* CTA Section */}
        <Box sx={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white", py: 12, position: "relative", overflow: "hidden", "&:before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)" }, "&:after": { content: '""', position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "radial-gradient(circle at 80% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)" } }}>
          <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
            <Fade in timeout={1000}>
              <Box sx={{ textAlign: "center" }}>
                <Typography variant="h2" gutterBottom sx={{ fontSize: { xs: "2rem", md: "2.75rem" }, fontWeight: 800 }}>
                  Ready to Transform Your Business Operations?
                </Typography>
                <Typography variant="h6" sx={{ mb: 5, opacity: 0.95, fontWeight: 400, lineHeight: 1.7, maxWidth: "600px", mx: "auto" }}>
                  Join thousands of teams who have streamlined their workflows with Synthium Business Suite. Start with a free trial and see the difference AI-enhanced operations can make.
                </Typography>
                <Box sx={{ display: "flex", gap: 3, justifyContent: "center", mb: 6, flexWrap: "wrap" }}>
                  <Button variant="contained" size="large" endIcon={<ArrowForward />} sx={{ px: 5, py: 2, bgcolor: "white", color: "#667eea", fontWeight: 700, fontSize: "1.1rem", borderRadius: 50, boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", "&:hover": { bgcolor: "#f8f9fa", transform: "translateY(-4px)", boxShadow: "0 12px 48px rgba(0, 0, 0, 0.3)" }, transition: "all 0.3s ease" }}>
                    Start Free Trial
                  </Button>
                  <Button variant="outlined" size="large" sx={{ px: 5, py: 2, color: "white", borderColor: "white", borderWidth: 2, fontWeight: 700, fontSize: "1.1rem", borderRadius: 50, backdropFilter: "blur(10px)", background: alpha("#ffffff", 0.1), "&:hover": { borderColor: "white", borderWidth: 2, background: alpha("#ffffff", 0.2), transform: "translateY(-4px)" }, transition: "all 0.3s ease" }}>
                    Schedule Demo
                  </Button>
                </Box>
                <Grid2 container spacing={6}>
                  {[{ s: "14 Days", s: " 14 Days Free Trial" }, { s: "No Setup", s: " No Setup Required" }, { s: "24/7", s: " 24/7 Support"}].map((item, i) => (
                    <Grid2 key={i} xs={12} md={4}>
                      <Box sx={{ textAlign: "center", p: 3, borderRadius: 3, background: alpha("#ffffff", 0.1), backdropFilter: "blur(10px)", transition: "all 0.3s ease", "&:hover": { background: alpha("#ffffff", 0.15), transform: "translateY(-4px)" } }}>
                        <Typography variant="h3" fontWeight={800} sx={{ mb: 1 }}>{item.t}</Typography>
                        <Typography variant="h6" sx={{ opacity: 0.9 }}>{item.s}</Typography>
                      </Box>
                    </Grid2>
                  ))}
                </Grid2>
              </Box>
            </Fade>
          </Container>
        </Box>

        {/* Footer */}
        <Box sx={{ bgcolor: "#1e293b", color: "white", py: 8 }}>
          <Container maxWidth="lg">
            <Grid2 container spacing={6}>
              <Grid2 xs={12} md={5}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
                  <Box component="img" src={fav} sx={{ width: 48, height: 48 }} />
                  <Typography variant="h4" sx={{ fontWeight: 800, background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                    Synthium Suite
                  </Typography>

                  
                </Box>
                <Typography variant="body1" sx={{ opacity: 0.8, mb: 3, maxWidth: "400px", lineHeight: 1.7 }}>
                  The operational engine of the Synthium ecosystem—designed for sales, client services, finance, and operations teams to execute strategy with speed, clarity, and intelligence.
                </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                  {[
                    { icon: Twitter, color: "#1DA1F2", link: "https://twitter.com" },
                    { icon: LinkedIn, color: "#0077B5", link: "https://linkedin.com" },
                    { icon: GitHub, color: "#ffffff", link: "https://github.com" },
                    //  { icon: Mail, color: "#ffffff", link: "https://gmail.com" },
                  ].map((social, index) => (
                    <IconButton key={index} sx={{ color: "white", bgcolor: alpha("#ffffff", 0.1), "&:hover": { color: social.color, bgcolor: alpha(social.color, 0.15), transform: "translateY(-4px)" }, transition: "all 0.3s ease" }} onClick={() => window.open(social.link, "_blank")}>
                      <social.icon />
                    </IconButton>
                  ))}
                </Box>
             
   <Typography
    sx={{
      fontSize: { xs: "14px", md: "20px" },
      fontWeight: 700,
      lineHeight: 1.4,
      textTransform: "uppercase",
      mb: 3,
      opacity: 0.9,
      maxWidth: "200px",
    }}
  >
    <h3>A Group of  JJFITZGERALD
   INNOVATIVE
   TECHNOLOGIES</h3>
  
  </Typography>

  <Grid2 xs={12} md={2}>
                {/* CONTACT */}
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2, opacity: 0.85 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <LocationOn fontSize="small" />
      <Typography sx={{ lineHeight: 1.4 }}>
        Maryland,
        United States
      </Typography>
    </Box>

       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <LocalPhone fontSize="small" />
      <Typography><b>301-997-5695</b></Typography>
    </Box>

       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Email fontSize="small" />
      <Typography><b>admin@synthiumsuite.com</b></Typography>
    </Box>
    </Box>
    </Grid2>
              </Grid2>
              <Grid2 xs={6} md={2.5}>
                <Typography variant="h6" gutterBottom fontWeight={700} sx={{ mb: 3 }}>
                  Product
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  {["Features", "Modules", "Products", "Security"].map((item) => (
                    <Typography key={item} variant="body1" sx={{ opacity: 1, cursor: "pointer", transition: "all 0.3s ease",
                     "&:hover": { opacity: 1, transform: "translateX(4px)", color: "#667eea" } }} onClick={() => scrollToSection(item.toLowerCase())}>
                      {item}
                    </Typography>
                  ))}
                </Box>

              </Grid2>
              <Grid2 xs={6} md={2.5}>
                <Typography variant="h6" gutterBottom fontWeight={700} sx={{ mb: 3 }}>
                  Company
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {["About", "Careers", "Contact", "Support"].map((item) => (
                    <Typography key={item} variant="body1" sx={{ opacity: 0.8, cursor: "pointer", transition: "all 0.3s ease", "&:hover": { opacity: 1, transform: "translateX(4px)", color: "#667eea" } }}>
                      {item}
                    </Typography>
                  ))}
                </Box>
              </Grid2>
              <Grid2 xs={12} md={2}>
                <Typography variant="h6" gutterBottom fontWeight={700} sx={{ mb: 3 }}>
                  Resources
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {["Documentation", "API Reference", "Community", "Blog"].map((item) => (
                    <Typography key={item} variant="body1" sx={{ opacity: 0.8, cursor: "pointer", transition: "all 0.3s ease", "&:hover": { opacity: 1, transform: "translateX(4px)", color: "#667eea" } }}>
                      {item}
                    </Typography>
                  ))}
                </Box>


<Box sx={{ maxWidth: "1200px", margin: "0 auto" }}>

    

  </Box>

              </Grid2>
            </Grid2>
            <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.1)", mt: 8, pt: 4, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
              <Typography variant="body2" sx={{ opacity: 0.6 }}>
                © {new Date().getFullYear()} Synthium Suite. All rights reserved.
              </Typography>
              <Box sx={{ display: "flex", gap: 3 }}>
                {["Privacy Policy", "Terms of Service", "Cookie Policy"].map((item) => (
                  <Typography key={item} variant="body2" sx={{ opacity: 0.6, cursor: "pointer", "&:hover": { opacity: 1, color: "#667eea" }, transition: "all 0.3s ease" }}>
                    {item}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Container>
        </Box>

        {/* Scroll to Top Button */}
        <ScrollTop>
          <Fab size="medium" aria-label="scroll back to top" sx={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white", boxShadow: "0 8px 24px rgba(102, 126, 234, 0.4)", "&:hover": { background: "linear-gradient(135deg, #5568d3 0%, #5d3981 100%)", transform: "scale(1.1)" }, transition: "all 0.3s ease" }}>
            <KeyboardArrowUp />
          </Fab>
        </ScrollTop>
      </Box>
    </ThemeProvider>
  );
}